// Certain browsers do not support localStorage during private browser sessions.

function isBrowserStorageSupported() {
	try {
		// To avoid collisions
		const uniqueKey = '0EsH3psWy7';
		localStorage.setItem(uniqueKey, uniqueKey);
		localStorage.removeItem(uniqueKey);
		return true;
	} catch (error) {
		return false;
	}
}

export default isBrowserStorageSupported;
